import React from "react";
import styled from "styled-components";
import { Spacing, ZIndexes, background, cover, transparentize } from "@glossy";
import { Locale } from "@linkfluence/models/locale";
import Button from "@ui-kit/button";
import { tr } from "@radarly/i18n";

export interface IProps {
  locale: Locale;
  onCancel: () => void;
  onSubmit: () => void;
}

const Root = styled.div`
  ${cover()};
  z-index: ${ZIndexes.Overlay};
  background-color: ${(props) => transparentize(0.2, background(props))};
  text-align: center;
  padding-top: calc(36px + ${Spacing.Medium});
  * + * {
    margin-left: ${Spacing.Medium};
  }
`;

const FilterbarOverlay = ({ locale, onCancel, onSubmit }: IProps) => (
  <Root>
    <Button
      text={tr(locale, "FORM::DRAFT_FILTERS::APPLY")}
      variant="primary"
      size="l"
      onClick={onSubmit}
    />
    <Button
      text={tr(locale, "FORM::DRAFT_FILTERS::CANCEL")}
      variant="secondary"
      size="l"
      onClick={onCancel}
    />
  </Root>
);

export default FilterbarOverlay;
